/* JCI: Reuses the Shopify-hosted demo; no autoplay or extra video library. */
window.JCIHome.register('twist-video', (root, on, cleanup) => {
  const video = root.querySelector('video'); const button = root.querySelector('.video-play'); const stage = root.querySelector('.video-stage');
  if (!video) { if (button) button.hidden = true; return; }
  video.controls = false;
  on(button, 'click', async () => { video.controls = true; try { await video.play(); } catch { button.hidden = true; } });
  on(video, 'play', () => stage.classList.add('is-playing'));
  on(video, 'ended', () => { stage.classList.remove('is-playing'); button.hidden = false; });
  on(video, 'error', () => { video.controls = true; button.hidden = true; });
  cleanup(() => video.pause());
});
